import type { NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { Profile } from '@/components/mygindumac/Profile';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import { useUser } from '@auth0/nextjs-auth0/client';
import Layout from '@/components/layout/Layout';
import { SignUpForm } from '@/components/mygindumac/Form/SignUpForm';
import { MdEmail } from 'react-icons/md';
import { Link } from 'next-translate-routes-multi-domain';
import useAccountManagerByEmail from '@/lib/hooks/useAccountManager';
import Seo from '@/components/Seo';
import { BENEDIKT_EMAIL } from '@/lib/data/account-managers';

const Index: NextPage = () => {
  const { t } = useTranslation();
  const { user } = useUser();
  const router = useRouter();
  useEffect(() => {
    if (user) {
      router.push('/my/dashboard');
    }
  }, [router, user]);

  const DANIEL = {
    name: 'Daniel Kaiser',
    email: 'd.kaiser@gindumac.com',
    profile_picture:
      'https://gindumac.s3.eu-central-1.amazonaws.com/staff/profile_pictures/Daniel_Kaiser.png',
    phone: '+49 174 262 96 14',
    linkedin: 'https://www.linkedin.com/in/danielkaiser86/',
    languages: 'ENGLISH_LANGUAGE,GERMAN_LANGUAGE,SPANISH_LANGUAGE',
    position: 'Co-CEO / Managing Partner',
    locales: [],
  };
  const verify_email = router.query?.verify_email;
  console.log('verify_email', verify_email);
  const { accountManager: Benedikt } = useAccountManagerByEmail(BENEDIKT_EMAIL);
  return (
    <Layout>
      <div className='bg-gray-100'>
        <div className='w-full '>
          <div className='container mx-auto bg-gray-100 pt-4 lg:max-w-5xl'>
            {verify_email !== undefined && (
              <div className='mx-4 bg-red-200 p-8 md:mr-0'>
                <div className='flex items-center space-x-4'>
                  <MdEmail className='text-2xl' />{' '}
                  <span className='text-2xl'>
                    {t('mygindumac:verify_email_before')}{' '}
                    <Link href={'/login'}>
                      <a className='text-blue-400 underline'>Login</a>
                    </Link>
                  </span>
                </div>
                {verify_email && (
                  <>
                    <div className='relative flex items-center py-5'>
                      <div className='flex-grow border-t border-gray-400' />
                      <span className='mx-4 flex-shrink text-gray-400'>
                        {"Can't find the email?"}
                      </span>
                      <div className='flex-grow border-t border-gray-400' />
                    </div>
                    <div className='flex w-full justify-center'>
                      <button
                        className='border-2 border-blue-500 p-2 text-blue-500'
                        onClick={() => {
                          fetch('/api/users/sendEmailVerification', {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({ user_email: verify_email }),
                          });
                        }}
                      >
                        <h5 className='uppercase'>resend verification link</h5>
                      </button>
                    </div>
                  </>
                )}
              </div>
            )}
            <div className='mx-4 grid gap-4 py-4 md:grid-cols-[60%_40%]'>
              <div className='bg-white px-4 py-8'>
                <h3 className='text-center text-3xl font-semibold text-gray-500'>
                  {t('mygindumac:Join Our Customer Portal')}
                </h3>
                <div className='mt-12 flex flex-col items-center justify-center'>
                  <div className='mt-12 space-y-4'>
                    <div className='flex items-center space-x-4'>
                      <AiOutlineCheckCircle className='h-12 w-12 text-gray-500' />{' '}
                      <h5 className='text-xl text-gray-600'>
                        {t('mygindumac:Project Tracking')}
                      </h5>
                    </div>
                    <div className='flex items-center space-x-4'>
                      <AiOutlineCheckCircle className='h-12 w-12 text-gray-500' />{' '}
                      <h5 className='text-xl text-gray-600'>
                        {t('mygindumac:Status Notifications')}
                      </h5>
                    </div>
                    <div className='flex items-center space-x-4'>
                      <AiOutlineCheckCircle className='h-12 w-12 text-gray-500' />{' '}
                      <h5 className='text-xl text-gray-600'>
                        {t('mygindumac:Referral Program')}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <SignUpForm />
            </div>
          </div>
        </div>
        <div className='w-full bg-white p-8'>
          <h2 className='text-center text-2xl font-bold'>
            {t('mygindumac:Your contact person')}
          </h2>
          <h3 className='text-center text-2xl '>
            {t('mygindumac:We are happy to be reached for you')}
          </h3>
          <div className='mx-auto mt-8 grid max-w-4xl grid-cols-1 gap-8 md:grid-cols-2'>
            {Benedikt && (
              <Profile
                photoUrl={Benedikt?.profile_picture}
                name={Benedikt?.name}
                position={Benedikt?.position ?? t('mygindumac:General Manager')}
                email={Benedikt.email}
                phone={Benedikt.phone}
                linkedin={Benedikt.linkedin}
              />
            )}

            <Profile
              photoUrl={DANIEL.profile_picture}
              name={DANIEL.name}
              position={DANIEL.position}
              email={DANIEL.email}
              phone={DANIEL.phone}
              linkedin={DANIEL.linkedin}
            />
          </div>
        </div>
      </div>
      <Seo
        title={t('mygindumac:mygindumac-title')}
        description={t('mygindumac:mygindumac-description')}
      />
    </Layout>
  );
};

export default Index;
